import CommunityLanding from "./CommunityLanding";

export default function ParticipantLanding({ isGuest = true, language = "en" }) {
  return <CommunityLanding variant="participant" isGuest={isGuest} language={language} />;
}
